import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, WarningCircle, ArrowRight } from '@phosphor-icons/react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }
    verify(token);
  }, [searchParams]);

  const verify = async (token) => {
    try {
      const { data } = await axios.get(`${API}/api/auth/verify-email?token=${token}`);
      setStatus('success');
      setMessage(data.message || 'Email verified!');
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.detail || 'Verification failed. The link may have expired.');
    }
  };

  return (
    <div className="min-h-screen bg-[#080808] flex items-center justify-center p-6">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md text-center">
        <div className="bg-zinc-900/50 backdrop-blur-sm border border-white/10 rounded-2xl p-10">
          {status === 'verifying' && (
            <>
              <div className="w-12 h-12 border-2 border-[#c8f060] border-t-transparent rounded-full animate-spin mx-auto mb-6" />
              <p className="text-zinc-300">Verifying your email...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle size={48} weight="fill" className="mx-auto mb-4" style={{ color: '#c8f060' }} />
              <h1 className="text-2xl font-medium font-['Instrument_Serif',serif] text-white mb-2">Email Verified</h1>
              <p className="text-zinc-400 text-sm mb-8">{message}</p>
              <Link to="/dashboard" data-testid="go-to-dashboard"
                className="inline-flex items-center gap-2 bg-[#c8f060] text-black px-6 py-3 rounded-full font-semibold hover:opacity-90 transition-opacity">
                Go to Dashboard <ArrowRight size={16} />
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <WarningCircle size={48} weight="fill" className="mx-auto mb-4" style={{ color: '#ef4444' }} />
              <h1 className="text-2xl font-medium font-['Instrument_Serif',serif] text-white mb-2">Verification Failed</h1>
              <p className="text-zinc-400 text-sm mb-8">{message}</p>
              <Link to="/login" className="text-[#c8f060] text-sm hover:underline">
                Back to login
              </Link>
            </>
          )}
        </div>
      </motion.div>
    </div>
  );
}
